import React, { useCallback, useEffect, useState } from "react";
import { LayoutGrid } from "lucide-react";
import { api } from "@/lib/api";
import { IntakeCard } from "@/components/workspace/IntakeCard";
import { StatsStrip, GettingStarted, ProjectList } from "@/components/workspace/Overview";
import { ProjectDetail } from "@/components/workspace/ProjectDetail";

export default function Workspace({ goTo }) {
  const [projects, setProjects] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [stats, setStats] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async (selectId) => {
    const [p, s] = await Promise.all([api.get("/projects"), api.get("/stats")]);
    setProjects(p.data);
    setStats(s.data);
    setActiveId((cur) => selectId || (cur && p.data.some((x) => x.id === cur) ? cur : p.data[0]?.id || null));
    setLoaded(true);
  }, []);
  useEffect(() => { load(); }, [load]);

  const replace = (proj) => {
    setProjects((ps) => ps.map((x) => (x.id === proj.id ? proj : x)));
    api.get("/stats").then((r) => setStats(r.data));
  };
  const active = projects.find((p) => p.id === activeId);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-8 space-y-6" data-testid="contractor-workspace">
      <StatsStrip stats={stats} />
      {loaded && <GettingStarted projects={projects} goTo={goTo} />}
      <div className="grid md:grid-cols-12 gap-8">
        <div className="md:col-span-5 space-y-6">
          <IntakeCard onCreated={(p) => load(p.id)} onUpgrade={() => goTo("settings")} />
          <ProjectList projects={projects} activeId={activeId} onSelect={setActiveId} />
        </div>
        <div className="md:col-span-7">
          {active ? <ProjectDetail project={active} onChange={replace} onDeleted={() => load()} /> : (
            <div className="border border-dashed border-border rounded-xl bg-card/50 p-14 text-center" data-testid="workspace-empty">
              <LayoutGrid className="h-10 w-10 mx-auto text-muted-foreground mb-4" strokeWidth={1.5} />
              <h3 className="font-display text-xl font-bold">No active project yet</h3>
              <p className="text-sm text-muted-foreground mt-2 max-w-sm mx-auto">Describe a job on the left (or tap an example) to generate your first milestone blueprint.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
